import React from "react";
import { Box, Typography } from "@mui/material";
// import UserListModaledit from "./UserListModaledit";
import CourseListModaledit from "./CourseListModaledit";
import { makeStyles } from "@mui/styles";
import { ChangeDate } from "../../helpers/Date";
import { useNavigate } from "react-router-dom";
import {Button} from "@mui/material";
// import { useParams } from "react-router-dom";

const CourseListtable = ({ no, item, render, setRender }) => {
  const navigate = useNavigate();
  // const { id } = useParams();
  const classes = useStyles();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          background: "#fff",
          color: "#fff",
          // height: "45px",
          width: "1500px",
        }}
      >
        <Typography
          sx={{
            width: "70px",
            display: "flex",
            color: "#fff",
            alignItems: "center",
            justifyContent: "center",
            borderLeft: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            borderBottom: "1px solid #e0e0ef",
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
          }}
        >
          {no + 1}
        </Typography>
        <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
          }}
        >
          {item.name}
        </Typography>
        <div></div>
        <Typography
          sx={{
            width: "400px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
          }}
        >
          {item.description}
        </Typography>
        <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            // height: 44,
            color: "#000",
            background: "#fff",
            fontSize: "13px",
          }}
        >
          <img className={classes.image} src={item.image} alt="" />
        </Typography>
        <Typography
          sx={{
            width: "180px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
          }}
        >
          {item.category}
        </Typography>
        <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            // height: 44,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
          }}
        >
          &nbsp;{ChangeDate(item.createdAt)}
        </Typography>
        {/* <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#004A99",
          }}
        >
          ရက်စွဲ 
        </Typography> */}
        <Typography
          sx={{
            width: "150px",
            display: "flex",
            alignItems: "center",
            borderLeft: "1px solid #e0e0ef",
            borderRight: "1px solid #e0e0ef",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            color: "#000",
            fontSize: "13px",
            background: "#fff",
            // height: 44,
            justifyContent: "center",
          }}
        >
          &nbsp;{ChangeDate(item.updatedAt)}
        </Typography>
        <Typography
          sx={{
            width: "150px",
            display: "flex",
            alignItems: "center",
            borderLeft: "1px solid #e0e0ef",
            borderRight: "1px solid #e0e0ef",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            // paddingLeft: 3,
            color: "#fff",
            background: "#fff",
            // height: 44,
            justifyContent: "center",
          }}
        >
          <CourseListModaledit
            render={render}
            setRender={setRender}
            item={item}
          />
          <Button sx={{boxShadow:'none !important'}} variant="contained"
            onClick={() => navigate(`/course/course-detail${item._id}`)}
          >
            detail
          </Button>
        </Typography>
      </Box>
    </>
  );
};

const useStyles = makeStyles({
  image: {
    width: "100%",
  },
});

export default CourseListtable;
